var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0605 15C21.0605 15.5304 20.8498 16.0391 20.4748 16.4142C20.0997 16.7893 19.591 17 19.0605 17H7.06055L3.06055 21V5C3.06055 4.46957 3.27126 3.96086 3.64633 3.58579C4.02141 3.21071 4.53011 3 5.06055 3H19.0605C19.591 3 20.0997 3.21071 20.4748 3.58579C20.8498 3.96086 21.0605 4.46957 21.0605 5V15Z",
    stroke: "#55595F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextMessage);
export default __webpack_public_path__ + "static/media/text-message.4ac2b4a08dbf3c95b1a80ef1dca79890.svg";
export { ForwardRef as ReactComponent };